import React from "react";
import { Box, Typography } from "@mui/material";
import ShieldRoundedIcon         from "@mui/icons-material/ShieldRounded";
import BarChartRoundedIcon        from "@mui/icons-material/BarChartRounded";
import AccountBalanceRoundedIcon  from "@mui/icons-material/AccountBalanceRounded";
import SettingsRoundedIcon        from "@mui/icons-material/SettingsRounded";
import { useNavigate } from "react-router-dom";

const T = { teal:"#007C84", tealDk:"#016268", tealLt:"#E0F4F5", border:"#E2E8F0", muted:"#64748B" };

const TABS = [
  { label:"Claims",    icon:<ShieldRoundedIcon />,        path:"/app/protection-claims",    idx:0 },
  { label:"Analytics", icon:<BarChartRoundedIcon />,      path:"/app/protection-analytics", idx:1 },
  { label:"Fund",      icon:<AccountBalanceRoundedIcon />, path:"/app/protection-fund",      idx:2 },
  { label:"Config",    icon:<SettingsRoundedIcon />,       path:"/app/protection-config",    idx:3 },
];

export default function ProtectionNav({ activeTab = 0 }) {
  const navigate = useNavigate();
  return (
    <Box sx={{ display:"flex", gap:0.5, bgcolor:"white", border:`1px solid ${T.border}`, borderRadius:"14px", p:0.75, mb:3, width:"fit-content" }}>
      {TABS.map(t => (
        <Box key={t.path} onClick={() => navigate(t.path)} sx={{
          display:"flex", alignItems:"center", gap:1,
          px:2.5, py:1.2, borderRadius:"10px", cursor:"pointer",
          bgcolor: t.idx===activeTab ? T.teal : "transparent",
          color:   t.idx===activeTab ? "#fff" : T.muted,
          fontWeight: t.idx===activeTab ? 700 : 500, fontSize:13, transition:"all 0.15s",
          "&:hover":{ bgcolor:t.idx===activeTab?T.teal:T.tealLt, color:t.idx===activeTab?"#fff":T.teal },
          fontFamily:"'Plus Jakarta Sans',sans-serif",
        }}>
          {React.cloneElement(t.icon, { sx:{ fontSize:16 } })}
          {t.label}
        </Box>
      ))}
    </Box>
  );
}
